export enum CategoryEnum {
  CONSULTING_OR_PROFESSIONAL_SERVICES = 'CONSULTING_OR_PROFESSIONAL_SERVICES',
  HARDWARE_OR_EQUIPMENT = 'HARDWARE_OR_EQUIPMENT',
  OTHER = 'OTHER',
  SOFTWARE = 'SOFTWARE',
}
